module.exports = "../../static/img/about_us.c16d645.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/about_us/about_us.png
// module id = hZnh
// module chunks = 1